import { Upload } from '@mui/icons-material';
import { Alert, Box, Button, Snackbar, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CloseIcon } from 'src/components/icons';
import { ApiApplication } from 'src/http';

export default function InputFileUpload({
  getFileValue,
  field,
  justifyContent,
  fileName,
}: // id,
{
  getFileValue: Function;
  field: string;
  justifyContent?: string;
  fileName: string | null;
  // id?: string | number;
}) {
  const { t } = useTranslation();
  // const [_fileName, _setFileName] = useState<string | null>(fileName);
  const [fileSizeExceeded, setFileSizeExceeded] = useState(false);
  const maxFileSize = 100 * 1024 * 1024;

  const sendFileValue = async (e: any) => {
    const file = e[0];
    if (file) {
      if (file.size > maxFileSize) {
        setFileSizeExceeded(true);
        return;
      } else {
        await uploadFile(file);
      }
    } else {
      reset();
    }
  };

  const reset = () => {
    // _setFileName('');
    getFileValue({
      file: null,
      field,
      fileName: '',
    });
  };

  const uploadFile = async (file: File) => {
    const formData = new FormData();
    formData.append('file', file);
    try {
      if (field === 'certificates') {
        await ApiApplication.certificatesUpload(formData);
      }
      if (field === 'CONFIRMED_TEST_TAKERS') {
        await ApiApplication.confirmedToTestTakersUpload(formData);
      }
      if (field === 'TEST_TAKERS_TO_OTHERS') {
        await ApiApplication.testTakersToOtherUpload(formData);
      }
      if (field === 'VERBAL_TO_TWICE') {
        await ApiApplication.verbalToTwiceUpload(formData);
      }
      if (field === 'VERBAL_TO_OTHER') {
        await ApiApplication.verbalToOtherUpload(formData);
      } else {
        const data = await ApiApplication.fileUpload(formData);
        getFileValue({
          file,
          field,
          fileName: data.filename,
        });
      }
      setFileSizeExceeded(false);
      setSnackOpen(true);
    } catch ({ message }: any) {
      console.log(message);
    }
  };

  // SNACK
  const [snackOpen, setSnackOpen] = useState(false);
  const [error, setError] = useState('');
  const handleCloseSnack = () => {
    setError('');
    setSnackOpen(false);
  };
  React.useEffect(() => {
    if (error !== '') {
      setSnackOpen(true);
    }
  }, [error]);

  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={snackOpen}
        autoHideDuration={6000}
        onClose={handleCloseSnack}
      >
        {error ? (
          <Alert onClose={handleCloseSnack} severity="error" sx={{ width: '100%' }}>
            <div> Ma'lumotlar yuklanmadi. Iltimos qaytadan urinib ko'ring! {error}</div>
          </Alert>
        ) : (
          <Alert onClose={handleCloseSnack} severity="success" sx={{ width: '100%' }}>
            Ma'lumotlar yuklandi
          </Alert>
        )}
      </Snackbar>
      <Box>
        {fileName === '' &&
        field !== 'certificates' &&
        field !== 'invoice' &&
        field !== 'CONFIRMED_TEST_TAKERS' &&
        field !== 'TEST_TAKERS_TO_OTHERS' &&
        field !== 'VERBAL_TO_OTHER' &&
        field !== 'VERBAL_TO_TWICE' ? (
          <Typography color={'red'} fontSize={18} marginTop={3}>
            {t('Please, upload pdf file')} {t('Файл 10 МБ дан ошмаслиги шарт')}
          </Typography>
        ) : null}
        {fileSizeExceeded ? (
          <Typography fontWeight={'600'} color={'red'} my={2}>
            {t('Файл 100 МБ дан ошмаслиги шарт')}
          </Typography>
        ) : null}
        <Box
          display={'flex'}
          alignItems={'center'}
          py={2}
          flexWrap={'wrap'}
          overflow={'hidden'}
          justifyContent={justifyContent ? justifyContent : 'unset'}
        >
          <Typography fontWeight={'600'}>{t(field)}:</Typography>&nbsp;
          {fileName === '' ? (
            <Button
              variant="contained"
              component="label"
              color="success"
              sx={{
                m: 1,
              }}
            >
              <Upload />
              {t('upload.file')}
              <Box sx={{ opacity: 0, width: '0px', overflow: 'hidden' }}>
                <input
                  // required
                  type="file"
                  name={field + '_1'}
                  onChange={(e) => sendFileValue(e.target.files)}
                  size={10}
                />
              </Box>
            </Button>
          ) : (
            <Box>
              {fileName}
              <Button
                variant="outlined"
                size="small"
                color="secondary"
                sx={{
                  m: 2,
                }}
                onClick={reset}
              >
                <CloseIcon />
              </Button>
            </Box>
          )}
        </Box>
      </Box>
    </>
  );
}
